var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.BOverlay,
    { attrs: { show: _setup.loading } },
    [
      _c(
        _setup.BFormRadioGroup,
        {
          attrs: { stacked: "" },
          model: {
            value: _setup.selectedFixing,
            callback: function ($$v) {
              _setup.selectedFixing = $$v
            },
            expression: "selectedFixing",
          },
        },
        [
          _c(
            _setup.BFormRadio,
            {
              staticClass: "mb-2",
              attrs: { value: "hanger", disabled: _setup.isHangerDisabled },
            },
            [
              _c("strong", [_vm._v("Easy Hanger")]),
              _vm._v("+ £0.00 "),
              _c("em", [_vm._v('(included in price, up to 20x16")')]),
            ]
          ),
          _c(_setup.BFormRadio, { attrs: { value: "string" } }, [
            _c("strong", [_vm._v("D-rings and String")]),
            _vm._v(_vm._s(_setup.diffInPrice)),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }